import React from 'react';
import RECREATE from '../../images/3386375.png';
import DELETE from '../../images/2723639.png';
import COPY from '../../images/4340830.png';
import SelectOptions from './SelectOptions';

const Order = ({order, updateOrder, handleCurrentOrders, employees, handleCurrentemployees}) => {

  const handleCopy = () => {
    const text = 
    `الاوردر:- ( ${order.value.text} ) \n- - - - - - - - - - - - \nالرقم:-  ${order.value.phone} `
    navigator.clipboard.writeText(text);
  }

  const handleSelectEmployer = (e) => {
    let aciton  = {
      type: 'ADD_ORDER',
      orderID: order.id,
    }
    
    handleCurrentemployees(e.target.value, aciton)
  }
  
  const handlePrice = (e) => {
    const price = e.target.value;
    if (price >= 5) {
      const newOrder = {...order}
      newOrder.price = price
      
      handleCurrentOrders(newOrder, 'update')
    }
  }

  return (
    <div className='order-con'>
      <div className={`order s ${order.state}`}>
        <div className='ope'>
          <div className='del' onClick={() => handleCurrentOrders(order, 'remove')}>
            <img src={DELETE} alt='delete icon' />
          </div>
          <div 
            className='copy'
            onClick={handleCopy}
          >
            <img src={COPY} alt='copy icon' />
          </div>
          <div className='finish'  onClick={() => handleCurrentOrders(order, 'finish')}>
            {order.state === 'fulfilled' && '✔'}
          </div>
        </div>
        <div className='value'>
          <div className='order-counter'>
            <p>{order.counter}</p>
          </div>
          <input 
            id='price'
            className='price choose-em' 
            type='number' 
            step='5' 
            min='5' 
            placeholder='$$$'
            value={order.price}
            onChange={handlePrice}
          />
          <select className='choose-em' value={order.employer} onChange={handleSelectEmployer}>
            <SelectOptions 
              options={employees} 
              state={order.state === 'end' ? 'end' : 'on'}
            />
          </select>
          <p className='phone-num'>{order.value.phone}</p>
          <p className='order-text'>
            {order.value.text}
          </p>
          <div className='recreate-con' onClick={() => updateOrder(order)}>
            <img className='recreate' src={RECREATE} alt='recreate icon' />
          </div>
        </div>
      </div>
      <p className='order-time'>{order.time}</p>    
    </div>
  )
}

export default Order;